
import {Options, Vue} from 'vue-class-component';
import './../less/elements/contactForm.less';
import {ErrorMessage, Field, Form} from 'vee-validate';
import * as yup from 'yup';
import axios from 'axios';


@Options({
    components: {
        Form,
        Field,
        ErrorMessage
    },
})
export default class ContactForm extends Vue {
    public name = '';
    public email = '';
    public message = '';
    public terms = false;
    public isSent = false;
    public isSending = false;
    public schema = yup.object({
        email: yup.string().required().email(),
        name: yup.string().required(),
        message: yup.string().required(),
        terms: yup.bool().oneOf([true], 'Field must be checked'),
    });

    send() {
        if (!this.isSending) {
            this.isSending = true
            const formData = new FormData()
            formData.append('name', this.name)
            formData.append('email', this.email)
            formData.append('message', this.message)
            formData.append('legal_statement_accepted', this.terms ? '1' : '0')
            axios.post('/api/v1/contacts', formData, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then(() => {
                this.isSent = true
                this.resetForm();
                this.isSending = false

            }).catch(() => {
                this.isSending = false

            })
        }
    }

    resetForm() {

        this.name = '';
        this.email = '';
        this.message = '';
        this.terms = false;
    }

    back() {
        this.resetForm();
        this.isSent = false
    }

}
